import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '../iconVariant';
import { IconProps } from '../types/IconInterface';

// The small icon on the circle avatar of the transaction details in this design:
// https://www.figma.com/design/bblnSSOHdRw4VImNVChx2K/Emerge-Customer-Web-Portal?node-id=6114-32811&t=dK9bbYlUWIaMxydA-4
const AttachmentCheckIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 9 11">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.200195 1.49998C0.200195 1.00292 0.603139 0.599976 1.1002 0.599976H5.2274C5.4661 0.599976 5.69502 0.694797 5.8638 0.86358L8.33659 3.33637C8.50537 3.50515 8.6002 3.73407 8.6002 3.97277V9.29998C8.6002 9.79703 8.19725 10.2 7.7002 10.2H1.1002C0.603139 10.2 0.200195 9.79703 0.200195 9.29998V1.49998ZM6.71413 4.91465C6.8603 4.71366 6.81587 4.43222 6.61487 4.28604C6.41388 4.13987 6.13244 4.1843 5.98626 4.3853L3.89601 7.2594L2.76839 6.13178C2.59266 5.95604 2.30773 5.95604 2.132 6.13178C1.95626 6.30751 1.95626 6.59244 2.132 6.76817L3.632 8.26817C3.72506 8.36123 3.85419 8.40889 3.9854 8.3986C4.1166 8.3883 4.23672 8.32109 4.31413 8.21465L6.71413 4.91465Z"
      fill="currentColor"
    />
  </svg>
);

export default AttachmentCheckIcon;
